// extracted by mini-css-extract-plugin
export default {"name":"\"scss\"","themeColor":"#409eff"};